(function () {
    function init() {
        var root = document.querySelector('[data-company-reviews]');
        if (!root || root.dataset.inited) return;
        root.dataset.inited = '1';
        var list = root.querySelector('.company-feedback__list');
        var sentinel = root.querySelector('.company-feedback__sentinel');
        var loading = root.querySelector('.company-feedback__load-status');
        var retry = root.querySelector('.company-feedback__retry');
        var end = root.querySelector('.company-feedback__end');
        var offset = Number(root.dataset.offset);
        var hasMore = offset < Number(root.dataset.total);
        var busy = false;
        var failed = false;
        var observer;
        function load() {
            if (busy || failed || !hasMore) return;
            busy = true;
            loading.hidden = false;
            retry.hidden = true;
            fetch(root.dataset.listUrl + '?offset=' + offset, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (response) {
                if (!response.ok) throw new Error('Load failed');
                return response.json();
            }).then(function (data) {
                if (!data.success) throw new Error('Load failed');
                list.insertAdjacentHTML('beforeend', data.html);
                offset = data.offset;
                root.dataset.offset = String(offset);
                hasMore = data.hasMore;
                end.hidden = hasMore;
                if (!hasMore && observer) observer.disconnect();
            }).catch(function () {
                failed = true;retry.hidden = false;
            }).finally(function () {
                busy = false;
                loading.hidden = true;
                if (!failed && hasMore) checkPosition();
            });
        }
        function checkPosition() {
            if (sentinel.getBoundingClientRect().top < window.innerHeight + 300) load();
        }
        retry.addEventListener('click', function () {
            failed = false;load();
        });
        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver(function (entries) {
                if (entries.some(function (entry) {
                    return entry.isIntersecting;
                })) load();
            }, { rootMargin: '300px 0px' });
            if (hasMore) observer.observe(sentinel);
        } else {
            window.addEventListener('scroll', checkPosition, { passive: true });
        }
        checkPosition();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
})();